



































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import ModalAddTabelaProfissional from './ModalAddTabelaProfissional.vue'

@Component({
  components: {
    ModalAddTabelaProfissional,
  },
})
export default class ModalTabelaPrestador extends Vue {
  readyState = false
  loadGestores = false
  loadModalAddGestor = false
  loadEditHospital = ''
  search = ''
  showModalDelete = false
  itemToDelete: string | null = null

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getProfissionais() {
    return this.getRecebimentoStore.tabelaProfissionaisById
  }

  get loadingShowModal() {
    return this.loadModalAddGestor
  }

  set loadingShowModal(value: boolean) {
    this.loadModalAddGestor = value
  }

  get loadingDeletePrestador() {
    return this.loadEditHospital
  }

  set loadingDeletePrestador(value: string) {
    this.loadEditHospital = value
  }

  get loadingDataTable() {
    return this.loadGestores
  }

  set loadingDataTable(value: boolean) {
    this.loadGestores = value
  }

  get headers() {
    return [
      { text: 'Profissional', class: 'table-headers', align: 'left', value: 'profissionalNome' },
      { text: 'Tabela preço', class: 'table-headers', align: 'left', value: 'tabelaPreco' },
      { text: 'Criado por', class: 'table-headers', align: 'left', value: 'createdBy' },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'createdOn' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModal() {
    return this.getRecebimentoStore.modalTabelaProfissional
  }

  set showModal(value: boolean) {
    this.getRecebimentoStore.setModalTabelaProfissional(value)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  async showModalAdd() {
    this.loadingShowModal = true
    this.getRecebimentoStore.setModalAddTabelaProfissional(true)
    this.loadingShowModal = false
  }

  openDeleteModal(id: string) {
    this.itemToDelete = id
    this.showModalDelete = true
  }

  async confirmDeleteItem() {
    if (!this.itemToDelete) return

    this.loadingDeletePrestador = this.itemToDelete
    const request = await this.getRecebimentoStore.deleteTabelaProfissional(this.itemToDelete)

    if (request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Profissional removido com sucesso!',
        icon: 'check',
        color: '#43A047',
      })
      this.getRecebimentoStore.getTabelaProfissionaisById()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.loadingDeletePrestador = ''
    this.showModalDelete = false
    this.itemToDelete = null
  }

  @Watch('showModal')
  onChangeShowModalPrestadores(value: boolean) {
    if (!value) this.search = ''
  }
}
